var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.95 4.411A.663.663 0 0011.334 4H4.667a.667.667 0 000 1.333h5.057l-5.529 5.529a.667.667 0 10.943.943l5.529-5.529v5.057a.667.667 0 101.333 0V4.667a.665.665 0 00-.05-.256z",
    fill: "currentColor"
  })));
}

export default SvgArrowRightUp;